import { DeleteSeasonalRulePayload } from 'models/seasonality/SeasonalRule';
import API from 'services/API';

export interface DeleteSeasonalRuleArgs {
  uid: string;
  payload: DeleteSeasonalRulePayload;
}

export const deleteSeasonalRule = async ({
  uid,
  payload,
}: DeleteSeasonalRuleArgs): Promise<void> => {
  await API.delete<void>(
    `/api/internal/seasonal-rules/cancellation-policies/${uid}`,
    { data: payload },
  );
};
